
<template>
  <div class="InformationContentManage">
    <div class="InformationContentManage-main">
      <div class="header-top">
        <div class="tabs-panle">
          <div class="tabs-wraper">
            <span
              v-for="(item,index) of taglist"
              :key="index"
              :class="[index===0 ?'frist' : '',searchForm.status===item.status?'active':'', index===taglist.length-1 ? 'last' : '']"
              @click="tabsFn(item.status)"
            >{{ item.name }}</span>
          </div>
        </div>
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            新增新闻
          </el-button>
        </div>
      </div>

      <div>
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="作者：" prop="author">
            <el-input
              v-model="searchForm.author"
              name="author"
              auto-complete="off"
              class="edit-form-input"
              placeholder="输入作者"
              clearable
            />
          </el-form-item>
          <el-form-item label="标题：" prop="title">
            <el-input
              v-model="searchForm.title"
              name="name"
              auto-complete="off"
              size="medium"
              class="edit-form-input"
              placeholder="输入标题"
              clearable
            />
          </el-form-item>
          <el-form-item :label="`${text}时间：`" prop="dateTime">
            <el-date-picker
              v-model="searchForm.dateTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="chooseThisDay(searchForm.dateTime)"
            />
          </el-form-item>

          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="标题" prop="title" align="center" />
          <el-table-column label="资讯类型" prop="typeName" width="220" align="center">
            <template slot-scope="scope">
              <p v-for="v of scope.row.typeName" :key="v" :title="v" style="text-align:left">
                {{ v }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="链接" prop="link" align="center" width="330">
            <template slot-scope="scope">
              <a :href="scope.row.link" class="link" target="_blank">{{ scope.row.link }}</a>
            </template>
          </el-table-column>
          <el-table-column label="作者" prop="author" align="center" />
          <el-table-column :label="`${text}时间`" prop="createDate" align="center" />
          <el-table-column label="操作" align="center" width="180px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="handleBatch(scope.row)"
              >
                {{ scope.row.status?'下线':'上线' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.text"
      width="960px"
    >
      <dialog-info
        :id="hiddenVariable.id"
        :type="hiddenVariable.type"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>

import DialogInfo from './dialogInfo';
// 获取API
import {
  getConsultingcontentsList,
  newsBatch
} from '@/api/productOperation/mrDesk/news';
export default {
  name: 'NewsContentManage',
  components: {
    DialogInfo
  },

  data() {
    return {
      // 弹框标题
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        type: 'add',
        id: '',
        text: ''
      },
      // 搜索表单
      searchForm: {
        author: '',
        dateTime: '',
        title: '',
        status: 1,
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      text: '上线',
      taglist: [
        { name: '已上线', status: 1 },
        { name: '已下线', status: 0 }
      ],
      dataList: [],
      listLoading: false // 表格刷新loading
    };
  },

  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取列表
    getInfo() {
      var option = {
        author: this.searchForm.author,
        dateTime: this.searchForm.dateTime,
        title: this.searchForm.title,
        status: this.searchForm.status,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getConsultingcontentsList(option)
        .then(res => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.dataList = [];
            this.searchForm.total = 0;
          } else {
            this.dataList = res.data.list;
            this.dataList.map(v => {
              if (v.typeName) {
                v.typeName = v.typeName.split(',');
              }
              return v;
            });
            this.searchForm.total = res.data.total;
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },
    tabsFn(val) {
      this.searchForm.pageNum = 1;
      this.searchForm.status = val;
      if (val) {
        this.text = '上线';
      } else {
        this.text = '下线';
      }
      this.getInfo();
    },
    // 日历中某天日期选择
    chooseThisDay(dataValue) {
      if (dataValue) {
        this.searchForm.dateTime = dataValue;
      } else {
        this.searchForm.dateTime = '';
      }
    },

    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },

    // 条件查询
    handleSearchFilter(val) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.listLoading = true;
      this.getInfo();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.ajaxLoading = false;
      this.hiddenVariable.text = type === 'add' ? ' 新增新闻' : '编辑新闻';
      this.hiddenVariable.type = type;
      if (type === 'edit') {
        this.hiddenVariable.id = row.id;
      }

      this.hiddenVariable.dialogEditVisible = true;
    },

    handleBatch(row) {
      var option = {
        ids: [row.id],
        status: row.status ? 0 : 1
      };
      newsBatch(option).then(res => {
        this.getInfo();
      });
    },
    closeDialogFn() {
      this.hiddenVariable.dialogEditVisible = false;
      this.getInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.InformationContentManage {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}
.link{
  color: #409eff;
  text-decoration: underline;
}

.header-top {
  display: flex;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
  text-align: center;
  align-items: center;
  .tabs-panle {
    flex: 1;
    .tabs-wraper {
      height: 42px;
      line-height: 42px;
      text-align: center;
      display: inline-block;
      padding: 0 10px;
      span {
        padding: 0 30px;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
      .frist {
        border-radius: 20px 0 0 20px;
        border-left: 1px solid #e5e5e5;
      }
      .last {
        border-radius: 0 20px 20px 0;
        border-right: 1px solid #e5e5e5;
      }
      .active {
        background: #409eff;
        color: #fff;
      }
    }
  }

}
</style>
